import { Auth0ContextInterface, useAuth0, withAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { invokeEvent } from 'shared-base';
import { setAuth0 } from '../../globals';

export type AuthProps = {
  auth0: Auth0ContextInterface;
};

export function Auth(props: AuthProps) {
  const { auth0 } = props;

  useEffect(() => {
    setAuth0(auth0);
  }, []);

  const { isAuthenticated, user, isLoading } = useAuth0();

  useEffect(() => {
    invokeEvent('AUTH_CHANGE', { user, isAuthenticated, isLoading });
  }, [isAuthenticated, user, isLoading]);

  return null;
}

export default withAuth0(Auth);
